import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import ArticlePage from './pages/ArticlePage'
import ArticlesPage from './pages/ArticlesPage'
import BombTimerPrivacyPolicyPage from './pages/BombTimerPrivacyPolicyPage'
import BombTimerTermsAndConditionsPage from './pages/BombTimerTermsAndConditionsPage'
import ContactUsPage from './pages/ContactUsPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsAndConditionsPage from './pages/TermsAndConditionsPage'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
        <Route path="/apps/bomb-timer/privacy-policy" element={<BombTimerPrivacyPolicyPage />} />
        <Route
          path="/apps/bomb-timer/privacy-policy/:locale"
          element={<BombTimerPrivacyPolicyPage />}
        />
        <Route
          path="/apps/bomb-timer/terms-and-conditions"
          element={<BombTimerTermsAndConditionsPage />}
        />
        <Route
          path="/apps/bomb-timer/terms-and-conditions/:locale"
          element={<BombTimerTermsAndConditionsPage />}
        />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
